<template>
    <div class="ma-1">
        <h4> متابعة الطلبات </h4>
        <!-- tabs -->
        <!-- filter -->
        <v-row>
            <v-col>
                <v-autocomplete 
                    dense
                    outlined
                    hide-details
                    :items="[]"
                    item-text="name"
                    item-value="id"
                    label="نوع الطلب"
                />
            </v-col>
            <v-col>
                <v-autocomplete 
                    dense
                    outlined
                    hide-details
                    :items="[]"
                    item-text="name"
                    item-value="id"
                    label="حالة الطلب"
                />
            </v-col>
            <v-col>
                <v-autocomplete 
                    dense
                    outlined
                    hide-details
                    :items="[]"
                    item-text="name"
                    item-value="id"
                    label="جهة الطلب"
                />
            </v-col>
            <v-col>
                <v-checkbox label="الطلبات المنتهية" class="mt-0" hide-details />
            </v-col>
        </v-row>
        <bee-handy-table
            :headers="headers"
            :items="[]"
            dense
            zebra
            :items-per-page="-1"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <tooltip :text="$T('tooltips.edit')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; dialog = true"
                            >
                            <v-icon
                                size="20"
                                color="edit-color">
                                $edit
                            </v-icon>
                        </v-btn>
                    </tooltip>

                    <tooltip :text="$T('tooltips.delete')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; deleteDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="alert-color  ">
                                $delete
                            </v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            headers: [
                {
                    text: 'اسم الطلب',
                    name: '',
                    value: ''
                },
                {
                    text: 'جهة الطلب',
                    name: '',
                    value: ''
                },
                {
                    text: 'تاريخ تقديم الطلب',
                    name: "",
                    value: ''
                },
                {
                    text: 'القسم',
                    name: '',
                    value: ''
                },
                {
                    text: 'إجراءات الطلب المنجزة',
                    name: '',
                    value: ''
                },
                {
                    text: 'تاريخ الإقفال',
                    name: '',
                    value: ''
                },
                {
                    text: 'حالة الطلب',
                    name: '',
                    value: ''
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
                // {
                //     text: ,
                //     name: ,
                //     value: 
                // }
            ]
        }
    }
}
</script>
